import React, { useState } from 'react';
import './LeftBar.scss';
import { FaChevronRight, FaChevronDown, FaBars } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import { useFormData } from '../../SubPages/JyotishSubpages/JanmaKundali/ContextData/ContextData';

const LeftBar = () => {
  const { userData } = useFormData();
  const [openDropdown, setOpenDropdown] = useState(null);
  const [sidebarOpen, setSidebarOpen] = useState(false); // NEW

  const toggleDropdown = (section) => {
    setOpenDropdown(openDropdown === section ? null : section);
  };

  return (
    <>
      {/* Hamburger menu (visible only on small screens via CSS) */}
      <div className="sidebar-toggle" onClick={() => setSidebarOpen(!sidebarOpen)}>
        <FaBars />
      </div>

      {/* Sidebar */}
      <div className={`leftbar-Container ${sidebarOpen ? 'active' : ''}`}>
        <div className="leftbar-content">
          {/* === User Profile === */}
          <div className="user" onClick={() => toggleDropdown("profile")}>
            <h3>
              {userData?.name}'s Profile{" "}
              {openDropdown === "profile" ? <FaChevronDown /> : <FaChevronRight />}
            </h3>
          </div>
          {openDropdown === "profile" && (
            <div className="sub-options">
              <p>Name: {userData?.name}</p>
              <p>Location: {userData?.city}</p>
              <p>Birth Details: {userData?.day}-{userData?.month}-{userData?.year}</p>
            </div>
          )}

          {/* === Calculations === */}
          <div className="options" onClick={() => toggleDropdown("calculations")}>
            <h3>
              Calculations{" "}
              {openDropdown === "calculations" ? <FaChevronDown /> : <FaChevronRight />}
            </h3>
          </div>
          {openDropdown === "calculations" && (
            <div className="sub-options">
              <Link to="basic-details"><p>Basic Details</p></Link>
              <Link to="planet-pos"><p>Planetary Positions</p></Link>
              <Link to="chalit"><p>Chalit Table</p></Link>
              <Link to="pras"><p>Prastharashtakvarga</p></Link>
              <Link to="ashtak"><p>Ashtak Varga Chart</p></Link>
              <Link to="aspect"><p>Planetary Aspect(Western)</p></Link>
              <Link to="Friends"><p>Friendship Table</p></Link>
              <Link to="Bhav-Madhya"><p>Aspect On Bhav Madhya</p></Link>
              <Link to="shad-bhav"><p>Shad Bala & Bhav Bala</p></Link>
              <Link to="D1-to-D16"><p>D1 To D16 Charts</p></Link>
              <Link to="Transit-Today"><p>Transit Today</p></Link>
            </div>
          )}

          {/* === Predictions === */}
          <div className="options" onClick={() => toggleDropdown("predictions")}>
            <h3>
              Predictions and Reports{" "}
              {openDropdown === "predictions" ? <FaChevronDown /> : <FaChevronRight />}
            </h3>
          </div>
          {openDropdown === "predictions" && (
            <div className="sub-options">
              <Link to="life"><p>Life Predictions</p></Link>
              <Link to="love"><p>Love Horoscope</p></Link>
              <Link to="career"><p>Career Horoscope</p></Link>
              <Link to="nature"><p>Nature Horoscope</p></Link>
            </div>
          )}

          {/* === Numerology === */}
          <div className="options" onClick={() => toggleDropdown("numerology")}>
            <h3>
              Numerology{" "}
              {openDropdown === "numerology" ? <FaChevronDown /> : <FaChevronRight />}
            </h3>
          </div>
          {openDropdown === "numerology" && (
            <div className="sub-options">
              <Link to="lucky"><p>Lucky Number</p></Link>
              <Link to="chineselucky"><p>Chinese Lucky Number</p></Link>
              <Link to="unlucky"><p>Unlucky Number</p></Link>
              <Link to="lifepath"><p>Path Number</p></Link>
              <Link to="destiny"><p>Destiny Number</p></Link>
            </div>
          )}

          {/* === Dasha === */}
          <div className="options" onClick={() => toggleDropdown("dasha")}>
            <h3>
              Dasha{" "}
              {openDropdown === "dasha" ? <FaChevronDown /> : <FaChevronRight />}
            </h3>
          </div>
          {openDropdown === "dasha" && (
            <div className="sub-options">
              <Link to="vim"><p>Vimshottari Dasha</p></Link>
              <Link to="yogini"><p>Yogini Dasha</p></Link>
              <Link to="char"><p>Char Dasha</p></Link>
            </div>
          )}

          {/* === Paid Consultation === */}
          <div className="options" onClick={() => toggleDropdown("paid")}>
            <h3>
              Paid Consultation{" "}
              {openDropdown === "paid" ? <FaChevronDown /> : <FaChevronRight />}
            </h3>
          </div>
          {openDropdown === "paid" && (
            <div className="sub-options">
              <Link to="/#contact"><p>Paid Consultation</p></Link>
            </div>
          )}

          
        </div>
      </div>
    </>
  );
};

export default LeftBar;
